// Referral / invite attribution helpers.
// Captures the inviter's code from ANY share-link style (?ref=, ?invite=, ?code=, ?invite_code=, /i/{code})
// and persists it so it survives navigation and applies at signup — powering the double-sided reward.

const KEY = "bloq_invite_code";
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
const PARAMS = ["ref", "invite", "invite_code", "code"];
const SHARE_BASE = process.env.REACT_APP_SHARE_BASE || "https://bloqtalk.app";

export function storeInvite(code) {
  const clean = (code || "").trim().toUpperCase();
  if (!clean) return "";
  try {
    localStorage.setItem(KEY, JSON.stringify({ code: clean, at: Date.now() }));
  } catch {
    /* ignore */
  }
  return clean;
}

export function getStoredInvite() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return "";
    const { code, at } = JSON.parse(raw);
    if (!code || Date.now() - at > TTL_MS) {
      localStorage.removeItem(KEY);
      return "";
    }
    return code;
  } catch {
    return "";
  }
}

export function clearStoredInvite() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

// Read an invite code from the current URL query and persist it. Called once on app load.
export function captureInviteFromUrl() {
  try {
    const sp = new URLSearchParams(window.location.search);
    for (const p of PARAMS) {
      const v = sp.get(p);
      if (v) return storeInvite(v);
    }
  } catch {
    /* ignore */
  }
  return getStoredInvite();
}

// Canonical shareable invite link → the SPA /i/{code} landing (perk + attribution).
export function inviteLink(code) {
  const clean = (code || "").trim().toUpperCase();
  return clean ? `${SHARE_BASE}/i/${clean}` : SHARE_BASE;
}
